import * as React from 'react'
import { fetchHelpTopics } from 'infra/services/help-topics'
import { Link, useHistory } from 'react-router-dom'
import { ActionHelperTypeStyle } from './styles'
import { translate } from '../../../../../i18n/index'
import { Button, Menu } from '@mui/material'
import { Help, PlayCircleFilled, PictureAsPdf } from '@mui/icons-material'

const ActionHelperType = () => {
  const history = useHistory()
  const [valuesToHelpTopics, setValuesToHelpTopics] = React.useState<any>([])
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  React.useEffect(() => {
    (async () => {
      const { data } = await fetchHelpTopics({
        enabled: 1,
        appWebPath: !stringContainsNumber(history.location.pathname).trim() ? 'home-ubere' : stringContainsNumber(history.location.pathname)
      })
      setValuesToHelpTopics(data['hydra:member'])
    })()
  }, [history.location.pathname])

  function stringContainsNumber(string: string) {
    const containNumber = /\d/.test(string)

    if (containNumber) {
      history.location.pathname = history.location.pathname.replace(/[0-9]/g, '') + ':id'
    }

    return history.location.pathname.replace('/', '')
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ActionHelperTypeStyle>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{
          textTransform: 'none',
          borderRadius: '50px',
          textDecoration: 'none',
          padding: 0,
          minWidth: 'initial'
        }}
      >
        <Help style={{ color: '#fff', fontSize: 30 }} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top', // <- Ponto de origem do menu (ajustado!)
          horizontal: 'right'
        }}
      >
        <Link onClick={handleClose} to={{ pathname: '/artigos-e-videos', state: history.location.pathname, search: 'filterType=article' }} className='customMenuHeaderLink'>
          <div style={{ display: 'flex', gap: '5px' }}>
            <PictureAsPdf style={{ color: '#8C2458', fontSize: 20 }} />
            <span style={{ fontSize: 14, color: '#343A40', fontWeight: 500 }}>{translate('labelTutorias')}</span>
          </div>
        </Link>
        <Link onClick={handleClose} to={{ pathname: '/artigos-e-videos', state: history.location.pathname, search: 'filterType=video' }} className='customMenuHeaderLink'>
          <div style={{ display: 'flex', gap: '5px' }}>
            <PlayCircleFilled style={{ color: '#8C2458', fontSize: 20 }} />
            <span style={{ fontSize: 14, color: '#343A40', fontWeight: 500 }}>{translate('labelVideos')}</span>
          </div>
        </Link>
      </Menu>
    </ActionHelperTypeStyle>
  )
}

export default ActionHelperType
